import React from 'react';
import Icon from '@avtechsoftware/react-component-library/src/components/common/Icon/Icon';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ErrorBanner from '@avtechsoftware/react-component-library/src/components/common/ErrorBanner';
import RenderAlertLimitReached from '../AlertLayout/RenderAlertLimitReached/RenderAlertLimitReached';
import { selectActiveSubscriptionCounts } from '../../../redux/slices/sessionSlice';
import NewAlertButton from '../AlertLayout/RenderAlertLayoutButton/NewAlertButton/NewAlertButton';
import AdvancedListSearch from '../../common/RaaLists/AdvancedListSearch/AdvancedListSearch';
import dispatchAction from '../../../redux/utils/dispatchAction';
import { fetchSavedSearches } from '../../../redux/slices/savedSearchesSlice/savedSearchesSlice';
import searchType from '../../../utility/types/SearchType';
import AlertListTable from './AlertListTable/AlertListTable';
import {
  fetchFilteredAlertList, refreshFilteredAlertList,
  selectAlertList, selectAlertListCrudStatus,
  setAlertListPage,
} from '../../../redux/slices/alertListSlice/alertListSlice';
import listAlertPropType from '../../../utility/PropTypes/listAlertPropType';
import EmptyAlertListMessageRender from './EmptyAlertListMessageRender/EmptyAlertListMessageRender';
import { CrudStatus } from '../../../utility/types/CrudStatus';

class AlertListLayout extends React.Component {
  constructor(props) {
    super(props);
    const { alertListCrudStatus } = this.props;
    this.state = {
      error: alertListCrudStatus === CrudStatus.ERROR,
    };
    this.getSearchedAlerts = this.getSearchedAlerts.bind(this);
    this.handleDismissError = this.handleDismissError.bind(this);
    this.getSearchedAlerts = this.getSearchedAlerts.bind(this);
    this.handleRefreshFilteredList = this.handleRefreshFilteredList.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatchAction(
      dispatch,
      fetchSavedSearches,
      searchType.ALERT,
    );
  }

  getSearchedAlerts(filters) {
    this.setState({ error: false });
    const { dispatch } = this.props;
    dispatchAction(
      dispatch,
      fetchFilteredAlertList,
      { filters },
    );
  }

  handleDismissError() {
    this.setState({ error: false });
  }

  handleRefreshFilteredList() {
    const { dispatch } = this.props;
    dispatch(refreshFilteredAlertList());
  }

  /* istanbul ignore next */
  render() {
    const {
      activeSubscriptionCounts,
      isOnDashboard,
      isPublicDashboard,
      alertList,
      dispatch,
    } = this.props;
    const {
      error,
    } = this.state;

    const { alertLimit, alertCount } = activeSubscriptionCounts;
    const isLimitReached = (alertLimit - alertCount) <= 0;

    return (
      <>
        <div className="row">
          <div className="col">
            <h2 className="mb-0">
              Alerts
              <a
                title="Alerts Knowledge Base"
                rel="noopener noreferrer"
                target="_blank"
                href="https://avtech.com/articles/223/how-to-create-alerts-in-roomalert-com-video/"
                className="text-muted small"
                style={{ textDecoration: 'none' }}
              >
                {' '}
                <span style={{ fontSize: 'smaller' }}>
                  <Icon icon="circle-question" size="xs" />
                </span>
              </a>
            </h2>
          </div>
          <div className="col text-right">
            <NewAlertButton isLimitReached={isLimitReached} />
          </div>
        </div>
        <div className="mb-4">
          <span className={`text-muted small ${isLimitReached ? 'text-danger' : ''}`}>
            {`${alertCount} ${alertCount === 1 ? 'alert' : 'alerts'}`}
            {Number(alertLimit) === 1000000 ? null : ` (of ${alertLimit} allowed)`}
            {isLimitReached && <RenderAlertLimitReached />}
          </span>
        </div>
        <hr />
        <div>
          {error && (
          <div className="row">
            <div className="col">
              <ErrorBanner onCloseError={this.handleDismissError}>
                Unexpected Error retrieving alerts.
              </ErrorBanner>
            </div>
          </div>
          )}
          {alertCount > 0 ? (
            <>
              <AdvancedListSearch
                searchType={searchType.ALERT}
                getSearchedResults={this.getSearchedAlerts}
                setListCurrPage={() => dispatch(setAlertListPage(0))}
              />
              <AlertListTable
                alertList={alertList}
                isPublicDashboard={isPublicDashboard}
                getSearchedResults={this.getSearchedAlerts}
              />
            </>
          )
            : (
              <EmptyAlertListMessageRender
                isOnDashboard={isOnDashboard}
                isPublicDashboard={isPublicDashboard}
              />
            )}
        </div>
      </>
    );
  }
}

AlertListLayout.defaultProps = {
  isPublicDashboard: false,
  isOnDashboard: false,
};

AlertListLayout.propTypes = {
  alertList: PropTypes.arrayOf(PropTypes.shape(listAlertPropType)).isRequired,
  activeSubscriptionCounts: PropTypes.shape({
    alertLimit: PropTypes.number,
    alertCount: PropTypes.number,
  }).isRequired,
  isPublicDashboard: PropTypes.bool,
  isOnDashboard: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  alertListCrudStatus: PropTypes.number.isRequired,
};

/* istanbul ignore next */
const mapStateToProps = (state) => ({
  activeSubscriptionCounts: selectActiveSubscriptionCounts(state),
  alertList: selectAlertList(state),
  alertListCrudStatus: selectAlertListCrudStatus(state),
});
export { AlertListLayout };
export default connect(mapStateToProps)(AlertListLayout);
